import { render } from "./OrganisationUsers.vue?vue&type=template&id=85ad7d52"
import script from "./OrganisationUsers.vue?vue&type=script&lang=js"
export * from "./OrganisationUsers.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__